@if (showBreadcrumbs) {
  <div class="mb-lg">
    <ng-content select="cft-breadcrumbs,cft-back-button"></ng-content>
  </div>
}
<div class="hero-cover relative overflow-hidden rounded-lg px-xl py-2xl shadow-3 md:px-3xl">
  <cft-wave-cover-image />
  <div class="relative z-10 space-y-xs">
    <ng-content select="cft-hero-cover-title, h1[cft-hero-cover-title]"></ng-content>
    <ng-content select="cft-hero-cover-plot, h2[cft-hero-cover-plot]"></ng-content>
  </div>
</div>
